import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const query = `
  mutation (
    $whyBlockTitle1: String
    $whyBlockContent1: String
    $whyBlockTitle2: String
    $whyBlockContent2: String
    $whyBlockImage1: String
    $whyBlockImage2: String
    $dynamicWhyHostInfoBlock: String
) {
  updateWhyHostPage (
    whyBlockTitle1: $whyBlockTitle1
    whyBlockContent1: $whyBlockContent1
    whyBlockTitle2: $whyBlockTitle2
    whyBlockContent2: $whyBlockContent2
    whyBlockImage1: $whyBlockImage1
    whyBlockImage2: $whyBlockImage2
    dynamicWhyHostInfoBlock: $dynamicWhyHostInfoBlock
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        whyBlockTitle1: values.dynamicWhyHostInfoBlock[0].whyBlockTitle1,
        whyBlockContent1: values.dynamicWhyHostInfoBlock[0].whyBlockContent1,
        whyBlockTitle2: values.dynamicWhyHostInfoBlock[0].whyBlockTitle2,
        whyBlockContent2: values.dynamicWhyHostInfoBlock[0].whyBlockContent2,
        whyBlockImage1: values.whyBlockImage1,
        whyBlockImage2: values.whyBlockImage2,
        dynamicWhyHostInfoBlock: JSON.stringify(values.dynamicWhyHostInfoBlock),
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
